if (typeof CartForm !== "function") {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector("form");

      this.querySelectorAll("[data-js-cart-item]").forEach((item) => {
        const remove = item.querySelector(".remove");
        if (remove) {
          remove.dataset.href = remove.getAttribute("href");
          remove.setAttribute("href", "");
          remove.addEventListener("click", (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector(".qty");
        if (qty) {
          qty.addEventListener(
            "input",
            debounce((e) => {
              e.preventDefault();
              e.target.blur();
              this.updateCartQty(item, parseInt(qty.value));
            }, 500)
          );
          qty.addEventListener("click", (e) => {
            e.target.select();
          });
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form.classList.add("processing");
      if (this.querySelector(".alert")) {
        this.querySelector(".alert").remove();
      }

      const body = JSON.stringify({
        line: parseInt(item.dataset.line),
        quantity: newQty,
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript",
        },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement("span");
            alert.classList.add("alert", "alert--error");
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }
          return fetch("?section_id=helper-cart");
        })
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser().parseFromString(
            text,
            "text/html"
          );
          const cartFormInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
          const cartSubtotalInnerHTML =
            sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

          const cartItems = document.getElementById("AjaxCartForm");
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();

          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent =
                cartItems.querySelector("[data-cart-count]").textContent;
            });
          document
            .querySelectorAll("[data-header-cart-total")
            .forEach((elm) => {
              elm.textContent =
                cartItems.querySelector("[data-cart-total]").textContent;
            });

          if (alert !== null) {
            this.form.prepend(alert);
          }

          document.getElementById("AjaxCartSubtotal").innerHTML =
            cartSubtotalInnerHTML;

          if (document.querySelector("shipping-notice")) {
            document
              .querySelector("shipping-notice")
              .updateCartTotal(
                sectionInnerHTML.getElementById("AjaxCartSubtotal").dataset
                  .cartTotal
              );
          }

          const event = new Event("cart-updated");
          this.dispatchEvent(event);

          var carttotalproducts = document.querySelectorAll(
            ".cart__items .cart-item"
          );
          var totalQty = 0;
          carttotalproducts.forEach(function (item) {
            var qty = parseInt(item.getAttribute("data-qty"));
            var comparePrice = parseFloat(item.getAttribute("data-compare-price"));
            var tags = item.getAttribute("data-tags") || "";

            console.log("Item => qty:", qty, "compare:", comparePrice);

            if (tags.includes("gift-box")) return;
            if (!comparePrice || comparePrice === 0) {
              totalQty += qty;
            }
          });

          var productbundlePopup =
            document.querySelector(".button__text.button_text_primary");


          if (productbundlePopup) {
            var boldTag = productbundlePopup.querySelector("b");
            var boldTagSpan = productbundlePopup.querySelector("span");
            if (boldTag) {
              if (totalQty == 1) {
                boldTag.textContent = "add any 2 and get 15% off";
                boldTag.style.display = "block";
                boldTagSpan.style.display = "inline-block";
              } else if (totalQty == 2) {
                boldTag.textContent = "add any 1 and get 15% off";
                boldTag.style.display = "block";
                boldTagSpan.style.display = "inline-block";
              } else {
                boldTag.style.display = "none";
                boldTagSpan.style.display = "none";
              }
            } else {
              console.error("Bold tag not found inside .cart_primary_btn");
            }
          } else {
            console.error(".cart_primary_btn element not found");
          }
        })
        .catch((e) => {
          console.log(e);
          let alert = document.createElement("span");
          alert.classList.add("alert", "alert--error");
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
          this.form.classList.remove("processing");
        });
    }
  }

  if (typeof customElements.get("cart-form") == "undefined") {
    customElements.define("cart-form", CartForm);
  }
}

if (typeof CartProductQuantity !== "function") {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector(".qty-minus").addEventListener(
        "click",
        this.changeCartInput.bind(this)
      );
      this.querySelector(".qty-plus").addEventListener(
        "click",
        this.changeCartInput.bind(this)
      );
    }
    changeCartInput() {
      setTimeout(() => {
        document
          .getElementById("AjaxCartForm")
          .updateCartQty(
            this.closest("[data-js-cart-item]"),
            parseInt(this.querySelector(".qty").value)
          );
      }, 50);
    }
  }

  if (typeof customElements.get("cart-product-quantity") == "undefined") {
    customElements.define("cart-product-quantity", CartProductQuantity);
  }
}

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {
  window.refreshCart = (openDrawer = true) => {
    return fetch("?section_id=helper-cart")
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(
          text,
          "text/html"
        );
        const cartFormInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
        const cartSubtotalInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

        const cartItems = document.getElementById("AjaxCartForm");
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
          elm.textContent =
            cartItems.querySelector("[data-cart-count]").textContent;
        });
        document.querySelectorAll("[data-header-cart-total").forEach((elm) => {
          elm.textContent =
            cartItems.querySelector("[data-cart-total]").textContent;
        });

        document.getElementById("AjaxCartSubtotal").innerHTML =
          cartSubtotalInnerHTML;
        if (document.querySelector("shipping-notice")) {
          document
            .querySelector("shipping-notice")
            .updateCartTotal(
              sectionInnerHTML.getElementById("AjaxCartSubtotal").dataset
                .cartTotal
            );
        }
        if (openDrawer && document.querySelector("[data-js-site-cart-sidebar]")) {
          document.querySelector("[data-js-site-cart-sidebar]").show();
        }

        if (document.querySelector("cart-recommendations")) {
          document.querySelector("cart-recommendations").innerHTML = "";
          document
            .querySelector("cart-recommendations")
            .generateRecommendations();
        }
      });
  };
}

// Shipping protection (cart drawer, markup in snippets/cart-subtotal.liquid).
// The product is only added when the customer clicks Checkout with the toggle on.
// Whenever they come back to the store it is taken out of the cart again, so it never shows as a cart line.
if (!window.shippingProtectionInit) {
  window.shippingProtectionInit = true;

  const postCartJSON = (url, body) =>
    fetch(`${url}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then((response) => {
      if (!response.ok) throw new Error(`Shipping protection request failed: ${response.status}`);
      return response.json();
    });

  // Removes the protection product if it's in the cart (only rendered as a hidden marker in cart-form.liquid).
  const removeShippingProtection = () => {
    const lines = document.querySelectorAll("[data-shipping-protection-line]");
    if (!lines.length) return Promise.resolve();
    return Array.from(lines)
      .reduce(
        (chain, line) =>
          chain.then(() =>
            postCartJSON(KROWN.settings.routes.cart_change_url, { id: line.dataset.key, quantity: 0 })
          ),
        Promise.resolve()
      )
      .then(() => window.refreshCart && window.refreshCart(false))
      .catch((e) => console.error(e));
  };

  // Toggle: remember the choice on the cart, so it stays the same when the drawer re-renders.
  document.addEventListener("change", (e) => {
    const toggle = e.target.closest("[data-shipping-protection-toggle]");
    if (!toggle) return;
    postCartJSON(KROWN.settings.routes.cart_update_url, {
      attributes: { _shipping_protection: toggle.checked ? "" : "no" },
    }).catch((e) => console.error(e));
  });

  // Checkout: add the protection product first (toggle on) or make sure it's not there (toggle off).
  document.addEventListener("click", (e) => {
    const button = e.target.closest("#site-cart-sidebar #CheckOut");
    const protection = document.querySelector("[data-shipping-protection]");
    if (!button || !protection) return;
    e.preventDefault();
    button.disabled = true;

    const wantsProtection = protection.querySelector("[data-shipping-protection-toggle]").checked;
    const variantId = parseInt(protection.dataset.variantId);
    const note = document.getElementById("cartSpecialInstructions");

    fetch(`${KROWN.settings.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const protectionItems = cart.items.filter((item) => item.variant_id === variantId);
        let chain = Promise.resolve();
        if (wantsProtection && protectionItems.length === 0) {
          chain = postCartJSON(KROWN.settings.routes.cart_add_url, { items: [{ id: variantId, quantity: 1 }] });
        }
        if (!wantsProtection) {
          protectionItems.forEach((item) => {
            chain = chain.then(() =>
              postCartJSON(KROWN.settings.routes.cart_change_url, { id: item.key, quantity: 0 })
            );
          });
        }
        // The checkout button normally submits the cart form, which also saves the order note.
        if (note) {
          chain = chain.then(() => postCartJSON(KROWN.settings.routes.cart_update_url, { note: note.value }));
        }
        return chain;
      })
      .catch((e) => console.error(e))
      .finally(() => {
        window.location.href = "/checkout";
      });
  });

  // Back from checkout: fresh page load, or the browser's back/forward cache (old cart markup, so refresh it first).
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", removeShippingProtection);
  } else {
    removeShippingProtection();
  }
  window.addEventListener("pageshow", (e) => {
    if (!e.persisted || !window.refreshCart) return;
    const button = document.querySelector("#site-cart-sidebar #CheckOut");
    if (button) button.disabled = false;
    window.refreshCart(false).then(removeShippingProtection);
  });
}
